import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { AuthProvider } from './context/AuthContextTest.js'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>

     <App />

  </AuthProvider>
)




